export default __webpack_public_path__ + "static/media/About_ProCompPPR.10e4e012.png";